/**
 * App-wide / platform constants.
 *
 * Only application-level and infrastructure constants belong here.
 * Domain-specific constants (routes, API endpoints, nav config) live in their
 * own domain files:
 *   - Value Matching routing → src/routes/valueMatching/routes.tsx
 */


export const DEFAULT_LOCALE = 'en-US';

export const NAV_MESSAGE_BUNDLE = 'components.navigation';
export const HEADER_MESSAGE_BUNDLE = 'components.header';
export const HOMEPAGE_MESSAGE_BUNDLE = 'pages.homepage';

export const MONS_ROUTE_BASE = '/AffordabilityWebsite'; // @TODO: This should be passed from CDK package once we have monster CDK integration

// eslint-disable-next-line no-secrets/no-secrets
// Meta tags defined by mons: https://code.amazon.com/packages/MonsControlPlane/blobs/a177198fae4e0af466f7f233fd690aa0bfc483ed/--/src/com/amazon/mons/control/html/SellerCentralLayoutHtmlResponseBuilder.java#L344
export const MONS_META_TAGS = {
  REQUEST_ID: 'a2z:request_id',
  SITE_NAME: 'a2z:mons_site_name',
  APP_NAME: 'a2z:mons_app_name',
  CSRF_TOKEN: 'anti-csrftoken-a2z',
};

export const IS_BEHIND_MONS = !SERVER_MODE || SERVER_MODE === 'mons';
